// import { Box, Typography } from "@mui/material";
// import React from "react";

// const StatsCard = ({ title, valueCount }) => {
  
//   return (
//     <Box
//       sx={{
//         position: "relative",
//         // boxShadow: "2.79px 2.79px 13.96px 0px #ECF0F2",
//         boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
//         padding: "20px",
//         textAlign: "center",
//         borderRadius: "13px",
//         border:"1px solid",
//         borderColor:"primary.main",
//         border:"1px solid",
//         borderBottom:"4px solid",
//         borderBottomColor:"primary.main"
//       }}
//     >
//       <Typography
//         variant="body2"
//         sx={{
//           fontSize: "22px",
//           color: "secondary.tuna",
//           fontWeight: "500",
//         }}
//       >
//         {title}
//       </Typography>
//       <Typography
//         variant="body2"
//         sx={{
//           fontSize: "33px",
//           color: "secondary.dark",
//           fontWeight: "700",
//           // fontFamily: "Roboto",
//         }}
//       >
//         {valueCount}
//       </Typography>
//       {/* <Box
//         sx={{
//           position: "absolute",
//           right: 0,
//           top: 0,
//           background: `linear-gradient(270deg,#fffc03 0%, #FFDF01 25.77%, #FFB900 69.77%, #EE9B0F 100%)`,
//           borderTopRightRadius: "13px",
//           padding: "10px",
//         }}
//       >
//         <Typography sx={{ color: "secondary.light", fontSize: "13px" }}>
//           Today
//         </Typography>
//       </Box> */}
//     </Box>
//   );
// };

// export default StatsCard;


import { Box, Typography } from "@mui/material";
import React from "react";

const TREND_META = {
  increase: { icon: "▲", color: "success.main", label: "Increase" },
  decrease: { icon: "▼", color: "error.main", label: "Decrease" },
  same: { icon: "––", color: "text.secondary", label: "No change" },
};

const StatsCard = ({ title, valueCount, trend }) => {
  const meta = trend ? TREND_META[trend] : null;

  return (
    <Box
      sx={{
        position: "relative",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        padding: "20px",
        textAlign: "center",
        borderRadius: "13px",
        border: "1px solid",
        borderColor: "primary.main",
        borderBottom: "4px solid",
        borderBottomColor: "primary.main",
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontSize: "22px", color: "secondary.tuna", fontWeight: "500" }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        {meta && (
          <Typography
            component="span"
            sx={{ fontSize: "26px", color: meta.color, fontWeight: "700" }}
          >
            {meta.icon}
          </Typography>
        )}
        <Typography
          variant="body2"
          sx={{
            fontSize: "33px",
            color: meta ? meta.color : "secondary.dark",
            fontWeight: "700",
          }}
        >
          {valueCount}
        </Typography>
      </Box>

      {/* {meta && (
        <Typography
          variant="caption"
          sx={{ color: meta.color, fontWeight: 600 }}
        >
          {meta.label}
        </Typography>
      )} */}
    </Box>
  );
};

export default StatsCard;